import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { AUTHORIZATION_PARAMETER } from '../constants';
import { AuthService } from './auth.service';
import {AppNavigationService} from "../service/app-navigation.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private appNavService: AppNavigationService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const token = next.queryParams[AUTHORIZATION_PARAMETER];
    if (token) {
      this.authService.login(token);
    }

    if (!this.authService.isLoggedIn()) {
      this.appNavService.goToAccessDenied();
      return false;
    }

    return true;
  }
}
